angular.module('gym.invoices').controller('InvoicesCtrl', ["$scope", "familyContact", function($scope, familyContact) {
  return $scope.familyContact = familyContact;
}]);
